module.exports = __webpack_public_path__ + "media/bandicam 2021-06-23 10-11-32-874.c9845e00.mp4";